// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* dateFoodMeals **********************************************************************
const INDEX_FEED_DATE_FOOD_MEALS_SUCCESS = "INDEX_FEED_DATE_FOOD_MEALS_SUCCESS";
const SHOW_FEED_DATE_FOOD_MEAL_SUCCESS = "SHOW_FEED_DATE_FOOD_MEAL_SUCCESS";
const STORE_FEED_DATE_FOOD_MEAL_SUCCESS = "STORE_FEED_DATE_FOOD_MEAL_SUCCESS";
const UPDATE_FEED_DATE_FOOD_MEAL_SUCCESS = "UPDATE_FEED_DATE_FOOD_MEAL_SUCCESS";
const DESTROY_FEED_DATE_FOOD_MEAL_SUCCESS =
  "DESTROY_FEED_DATE_FOOD_MEAL_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* dateFoodMeals **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FEED_DATE_FOOD_MEALS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FEED_DATE_FOOD_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FEED_DATE_FOOD_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FEED_DATE_FOOD_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FEED_DATE_FOOD_MEAL_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* dateFoodMeals **********************************************************************

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("DateFoodMeal@index") || app.can("Reserve@index")) {
      api
        .get("/feeding/date_food_meal_assign", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing DateFoodMeals Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.DateFoodMeal",
              "DateFoodMeal"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyDateFoodMeals() {
  return _indexSuccess({ data: { dateFoodMeals: [] }, meta: {} });
}

/**
 *
 * @param {Number} dateFoodMeal
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(dateFoodMeal, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("DateFoodMeal@index")) {
      api
        .get(`/feeding/date_food_meal_assign/${dateFoodMeal}`, { params })
        .then((res) => {
          dispatch(_showSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing DateFoodMeal Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.DateFoodMeal",
              "DateFoodMeal"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyDateFoodMeal() {
  return _showSuccess({ data: { dateFoodMeal: {} }, meta: {} });
}

/**
 *
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("DateFoodMeal@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Adding New DateFoodMeal")
      );

      api
        .post("/feeding/date_food_meal_assign", {
          data: { dateFoodMealAssign: data },
          params,
        })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.New DateFoodMeal Added Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "خطا در ارسال اطلاعات",
              app.translate("routes.home.feed.Adding New DateFoodMeal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.DateFoodMeal",
              "DateFoodMeal"
            )} - ${app.translate(
              "routes.home.basic.permission.store",
              "store"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} dateFoodMeal
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(dateFoodMeal, data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("DateFoodMeal@update")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Updating DateFoodMeal")
      );

      api
        .put(`/feeding/date_food_meal_assign/${dateFoodMeal}`, {
          data: { dateFoodMeal: data },
          params,
        })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.DateFoodMeal Updated Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات بروزرسانی با شکست مواجه شد",
              app.translate("routes.home.feed.Updating DateFoodMeal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.DateFoodMeal",
              "DateFoodMeal"
            )} - ${app.translate(
              "routes.home.basic.permission.update",
              "update"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} dateFoodMeal
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(dateFoodMeal, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("DateFoodMeal@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Removing DateFoodMeal")
      );

      api
        .delete(`/feeding/date_food_meal_assign/${dateFoodMeal}`, { params })
        .then((res) => {
          dispatch(_destroySuccess(dateFoodMeal));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.DateFoodMeal Removed Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات حذف با شکست مواجه شد",
              app.translate("routes.home.feed.Removing DateFoodMeal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.DateFoodMeal",
              "DateFoodMeal"
            )} - ${app.translate(
              "routes.home.basic.permission.destroy",
              "destroy"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    dateFoodMeals: [],
    dateFoodMeal: {},
    meta: {},
  },
  action
) {
  let dateFoodMeals;
  let _index;
  switch (action.type) {
    case INDEX_FEED_DATE_FOOD_MEALS_SUCCESS:
      return Object.assign({}, state, {
        dateFoodMeals: action.payload.data.dateFoodMeals,
        meta: action.payload.meta,
      });
    case SHOW_FEED_DATE_FOOD_MEAL_SUCCESS:
      return Object.assign({}, state, {
        dateFoodMeal: action.payload.dateFoodMeal,
      });
    case STORE_FEED_DATE_FOOD_MEAL_SUCCESS:
      dateFoodMeals = app._.cloneDeep(state.dateFoodMeals);
      dateFoodMeals.push(action.payload);
      return Object.assign({}, state, {
        dateFoodMeals,
      });
    case UPDATE_FEED_DATE_FOOD_MEAL_SUCCESS:
      dateFoodMeals = app._.cloneDeep(state.dateFoodMeals);
      _index = dateFoodMeals.findIndex(
        (_dateFoodMeal) => _dateFoodMeal.id === action.payload.id
      );
      dateFoodMeals[_index] = action.payload;
      return Object.assign({}, state, {
        dateFoodMeals,
      });
    case DESTROY_FEED_DATE_FOOD_MEAL_SUCCESS:
      dateFoodMeals = app._.cloneDeep(state.dateFoodMeals);
      _index = dateFoodMeals.findIndex(
        (_dateFoodMeal) => _dateFoodMeal.id === action.payload
      );
      dateFoodMeals.splice(_index, 1);
      return Object.assign({}, state, {
        dateFoodMeals,
      });
    default:
      return state;
  }
}
